import { InfoCircleOutlined } from "@ant-design/icons";
import {
  Alert,
  Avatar,
  Button,
  DatePicker,
  Dropdown,
  Input,
  InputNumber,
  Menu,
  Modal,
  Select,
  Skeleton,
  Switch,
  Tooltip,
} from "antd";
import { Drawer } from "@src/appV2/redesign/components/Drawer";
import { ModalStatus, type UseModalState } from "@src/lib/ui-react";
import React from "react";
import {
  WorkerStages,
  WorkerSubstages,
  WorkerSubstage,
  getWorkerShiftTypeLabel,
} from "../../../appV2/redesign/utils/worker";

import { formatDateTimeWithTimeZone } from "@clipboard-health/date-time";
import { Banner } from "@src/lib/ui-react";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, Stack } from "@mui/material";
import { WorkerSignedAgreementsSection } from "@src/appV2/Agreements/WorkerSignedAgreementsSection";
import { CopyableText } from "@src/appV2/CopyableText/CopyableText";
import { EMPLOYEE_ROLES } from "@src/appV2/Employee/constants";
import { HomeHealthWorkerEnabledToggle } from "@src/appV2/ExperimentalHomeHealth/lib/HomeHealthWorkerEnabledToggle";
import { WorkerLockStatusDisplay } from "@src/appV2/ExperimentalHomeHealth/lib/WorkerLockStatusDisplay";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags";
import { logEvent } from "@src/appV2/lib/analytics";
import { showErrorToast, showInfoToast, showSuccessToast } from "@src/appV2/lib/Notifications";
import { EMPLOYMENT_STATUS } from "@src/constants/agents";
import { WorkerTypes } from "@src/appV2/redesign/utils/WorkerTypes";
import _ from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { logError } from "src/appV2/lib/analytics";
import { LicenseManager } from "src/components/licenseManager";
import { LicenseChangeLogsCard } from "src/components/licenseManager/licenseChangeLogs";
import { getUniqueQualifications } from "src/components/licenseManager/utils";
import { NotificationPreference } from "src/containers/agentDrawer/notificationPreference";
import { ShiftSearchPreference } from "src/containers/agentDrawer/shiftSearchPreference";
import { getFSSProfilePicDistributionURL } from "src/utils/fssUtils";
import request from "superagent";
import { AgentExperienceTags } from "../../../components/AgentExperienceTags/";
import DisabledInputPopover from "../../../components/disabledInputPopover";
import { Edit } from "../../../components/edit";
import { EditSSN } from "../../../components/editSSN";
import { ProfileChangeLogsCard } from "../../../components/profileChangeLogs";
import { ProfileImageModal } from "../../../components/profileImage";
import SelectLocations from "../../../components/selectLocations";
import SelectMetropolitanStatisticalArea from "../../../components/SelectMetropolitanStatisticalArea";
import { StatusChangeLogsCard } from "../../../components/StatusChangeLogsCard";
import { ADMIN_EVENTS } from "../../../constants/firebaseEvents";
import nlcStates from "../../../data/nlcStates.json";
import { pseudo } from "../../../modules/session";
import { getErrorMessage } from "../../../utils/errors";
import meta from "../../../utils/meta";
import { fullNameToFirstLast } from "../../../utils/string";
import { getAuthHeader } from "../../../utils/superagent";
import { FirebaseSyncButton } from "../../agentDrawer/actionButtons";
import { ViewUXCamSessionsButton } from "@src/appV2/UXCam/components/ViewUXCamSessionsButton";
import { UploadedDocs } from "../../agentDrawer/uploadedDocs";
import { HcpRequirement } from "../../userRequirements";
import { WorkerStagesButtonGroup } from "../agents/WorkerStagesButtonGroup";
import { WorkerStagesModal } from "../agents/WorkerStagesModal";
import { LocationContainer } from "../locationContainer";
import { LogContainer } from "../logContainer";
import { RequirementsModal } from "../requirementsModal";
import { AgentAppLinksCard } from "./agentAppLinksCard";
import { AgentPaymentsInfoCard } from "./agentPaymentsInfoCard";
import { updateHCPStage } from "./api";
import { SSN_DEFAULT_LABEL } from "./constants";
import { DeleteUserModal } from "./deleteUserModal";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { UpdateWorkerParams, WorkerSex } from "@src/appV2/Worker/types";
import { WorkerRolesManager } from "@src/components/workerRolesManager";
import { SyncWorkerWithZendeskButton } from "@src/appV2/Zendesk/components/SyncWorkerWithZendeskButton";
import { AgentReferral } from "../agents/AgentReferral";

const { TextArea } = Input;
// NLC multi state option
const NLCMultiState = "NLC Multi-state";

const twoSpace = <div style={{ height: 16 }} />;

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class WorkerDrawer extends React.Component<any, any> {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any = {
    editingDocuments: false,
    selectedDocument: null,
    optionalFulfillments: [],
    user: null,
    notes: "",
    candidateActionLoading: false,
    showProfileImageModal: {
      show: false,
      action: undefined,
    },
    reviews: [],
    isStagesModalVisible: false,
    selectedStage: null,
    notificationPreferences: {},
    instantPayPercentage: 100,
    experience: [],
    refreshRequirementListId: 0,
    editedValues: {},
    statusLogs: [],
    licensedStates: [],
    deleteUserModalVisible: false,
    profileImageSrc: {},
  };

  async componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId && this.props.userId) {
      await this.retrieveUser();
      logEvent(ADMIN_EVENTS.OPEN_HCP_DRAWER);
      void this.getAgentStatusLogs();
    }
  }

  filterManager = (input, option) =>
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  retrieveUser = async () => {
    const { userId } = this.props;
    const {
      body: { agentList },
    } = await request
      .get(`${global.api}/user/agentList`)
      .query({ userIds: [userId] })
      .set(await getAuthHeader());

    const user = agentList[0];
    this.setState({ instantPayPercentage: 100 });
    const selectedStates = [...(user?.agent?.licensedStates || [])];
    if (user?.agent?.license?.state && !selectedStates.includes(user.agent.license.state)) {
      selectedStates.push(user.agent.license.state);
    }
    this.setState({
      user,
      notes: user["agent"]["note"],
      licensedStates: selectedStates,
    });

    const imagePublicUrl = await getFSSProfilePicDistributionURL(userId);
    if (imagePublicUrl) {
      this.setState({ profileImageSrc: { src: imagePublicUrl } });
    }
  };

  saveUser = async (data, refresh = false) => {
    return request
      .put(`${global.api}/user/put`)
      .set(await getAuthHeader())
      .send({ ...data, performedBy: this.props.currentUserID })
      .then(() => {
        if (refresh) {
          void this.retrieveUser();
        }
      });
  };

  saveAgent = async (data: UpdateWorkerParams, refresh = false) => {
    if (data.experience) {
      const currentExpr = this.state.experience.findIndex(
        ({ exprType }) => exprType === data.experienceType
      );

      if (currentExpr >= 0) {
        const allowedStateExpr = this.state.experience[currentExpr].experience.filter(
          (experience) => data.experience?.includes(experience)
        );
        const newExperience = Array.from(new Set([...data.experience, ...allowedStateExpr]));
        this.setState((prevState) => {
          const updatedExperience = [...prevState.experience];
          updatedExperience[currentExpr].experience = newExperience;
          return { experience: updatedExperience };
        });
      } else {
        const newExpr = {
          experience: data.experience,
          exprType: data.experienceType,
        };
        this.setState((prevState) => ({
          experience: [...prevState.experience, newExpr],
        }));
      }

      this.setState({
        experience: this.state.experience,
      });
      data.experience = this.state.experience.flatMap(({ experience }) => experience);
    }
    return request
      .put(`${global.api}/agentprofile/put`)
      .set(await getAuthHeader())
      .send({ ...data, performedBy: this.props.currentUserID })
      .then(() => {
        if (refresh) {
          return this.retrieveUser();
        }
      })
      .catch((error) => {
        showErrorToast(getErrorMessage(error));
      });
  };

  updateAgentStage = async (
    stage: string,
    currentSubstage: WorkerSubstage | undefined,
    reason?: string,
    note?: string
  ) => {
    const { userId, currentUserID, profile: adminProfile } = this.props;
    this.setState({ isStagesModalVisible: false });

    const { limited, warning } = this.props.ldFlags?.[
      CbhFeatureFlag.BASKET_SIZE_LIMIT_CONFIGURATION
    ] ?? {
      limited: { enabled: false },
      warning: { enabled: false },
    };
    let newStage = stage;

    let substage = currentSubstage;
    if (limited.enabled && stage === WorkerSubstages.LIMITED) {
      const { scoreThreshold, basketSize, leadTimeThresholdInHrs } = limited;
      newStage = WorkerStages.ENROLLED;
      substage = {
        name: WorkerSubstages.LIMITED,
        accessMetadata: {
          scoreThreshold,
          basketSize,
          leadTimeThresholdInHrs,
        },
      };
    }

    if (warning.enabled && stage === WorkerSubstages.WARNING) {
      const { scoreThreshold, basketSize, leadTimeThresholdInHrs, failRestrictionDurationInDays } =
        warning;
      newStage = WorkerStages.ENROLLED;
      substage = {
        name: WorkerSubstages.WARNING,
        accessMetadata: {
          scoreThreshold,
          basketSize,
          leadTimeThresholdInHrs,
          failRestrictionDurationInDays,
        },
      };
    }

    if (stage === WorkerSubstages.INVITE_REQUIRED) {
      newStage = WorkerStages.RESTRICTED;
      substage = { name: WorkerSubstages.INVITE_REQUIRED };
    } else if (stage === WorkerStages.ENROLLED || stage === WorkerStages.RESTRICTED) {
      substage = undefined;
    }

    try {
      await updateHCPStage({
        adminId: currentUserID,
        adminName: adminProfile.name,
        agentId: userId,
        stage: newStage,
        substage,
        reason,
        note,
      });
      showSuccessToast("HCP stage updated.");
      void this.retrieveUser();
      void this.getAgentStatusLogs();
    } catch (error: unknown) {
      logError("Error in WorkerDrawer - updateAgentStage", { error });

      // Type guard to check if it's a superagent error
      const isSuperagentError = (
        err: unknown
      ): err is { response: { body: { message?: string } } } => {
        return typeof err === "object" && err !== null && "response" in err;
      };

      // Extract error message from backend response if available
      const errorMessage =
        isSuperagentError(error) && error.response?.body?.message
          ? `due to: ${error.response.body.message}`
          : "Please try again.";

      showErrorToast(`HCP stage could not be updated ${errorMessage}`);
    }
  };

  saveEditChanges = async (data: UpdateWorkerParams, refresh = false) => {
    const { fullSocialSecurityNumber, profileVideoUrl } = data;
    const email = isDefined(data.email) ? data.email.trim() : data.email;
    const phone = isDefined(data.phone) ? data.phone.trim() : data.phone;
    if (isDefined(email) && email.length === 0) {
      throw new Error("Email must not be empty");
    }
    if (isDefined(phone) && phone.length === 0) {
      throw new Error("Phone must not be empty");
    }
    if (phone && phone.length !== 10) {
      throw new Error("Please enter a valid phone number!");
    }
    if (fullSocialSecurityNumber && !/^\d{9}$/.test(fullSocialSecurityNumber)) {
      throw new Error("Please enter a valid SSN (9 digits)");
    }
    if (profileVideoUrl && !profileVideoUrl.startsWith("https://")) {
      throw new Error("Please enter a valid video URL starting with https://");
    }
    const result = await request
      .put(`${global.api}/agentprofile/put`)
      .set(await getAuthHeader())
      .send({ ...data, email, phone, performedBy: this.props.currentUserID });

    if (refresh) {
      void this.retrieveUser();
    }
    return result;
  };

  updateAgentRequirements = async (requirements) => {
    const payload = {
      agentId: this.props.userId,
      requirements,
      performedBy: this.props.currentUserID,
    };

    return request
      .post(`${global.api}/agentprofile/requirements`)
      .set(await getAuthHeader())
      .send(payload);
  };

  requirements = (agent) => {
    return (
      <HcpRequirement
        hcpId={agent.userId}
        key={this.state.refreshRequirementListId}
        agentTMZ={agent.tmz}
      />
    );
  };

  handleClose = () => {
    const { userId, retrieveUser, closeDrawer } = this.props;

    if (retrieveUser) {
      retrieveUser(userId);
    }

    closeDrawer();
    this.setState({ user: null, profileImageSrc: {} });
  };

  refreshAttendance = () => {
    const { user } = this.state;

    const onOk = async () => {
      const response = await request
        .post(`${global.api}/agentprofile/refreshAttendance`)
        .set(await getAuthHeader())
        .send({ agentId: user._id });

      return response;
    };

    Modal.confirm({
      title: `Refresh attendance for ${user.agent.name}?`,
      content: (
        <Alert
          type="warning"
          message="Normally attendance updates when a shift is assigned or cancelled for an agent."
        />
      ),
      onOk,
      okText: "Refresh",
    });
  };

  confirmTypeChange = (value) => {
    const { user } = this.state;
    Modal.confirm({
      title: `Are you sure you want to change type to ${getWorkerShiftTypeLabel(value)}`,
      onOk: () => {
        void this.saveAgent({ agentId: user._id, qualification: value }, true);
      },
    });
  };

  confirmModal = (field: "dob" | "employmentStatus", fieldDisplay, value) => {
    Modal.confirm({
      title: `Are you sure you want to change ${fieldDisplay}?`,
      onOk: () => {
        const { user } = this.state;
        void this.saveAgent({ agentId: user._id, [field]: value }, true);
      },
    });
  };

  confirmEmploymentStatusChange = (value) => {
    this.confirmModal("employmentStatus", "Employment Status", value);
  };

  dobChange = (value) => {
    const { user } = this.state;
    this.setState(
      {
        user: {
          ...user,
          agent: { ...user.agent, dob: value.format("YYYY-MM-DD") },
        },
      },
      this.confirmDobChange
    );
    this.addEdited("dob");
  };

  addEdited = (field) => {
    this.setState({
      editedValues: { ...this.state.editedValues, [field]: true },
    });
  };

  removeEdited = (field) => {
    this.setState({
      editedValues: { ...this.state.editedValues, [field]: false },
    });
  };

  confirmDobChange = () => {
    if (this.state.editedValues.dob) {
      this.confirmModal("dob", "Date of Birth", this.state.user.agent.dob);
      this.removeEdited("dob");
    }
  };

  onUpdateDocument = () => {
    this.setState({ refreshRequirementListId: Math.random() });
  };

  handleLicensedStates = async (value) => {
    const { licensedStates, user } = this.state;
    const multiStateAlreadySelected = licensedStates?.includes(NLCMultiState);
    let selectedStates = value;
    const multiStateIndex = value.indexOf(NLCMultiState);
    if (multiStateIndex !== -1) {
      if (!multiStateAlreadySelected) {
        selectedStates = [...value, ...nlcStates];
      } else {
        if (!nlcStates.every((val) => value.includes(val))) {
          selectedStates.splice(multiStateIndex, 1);
        }
      }
    } else if (multiStateAlreadySelected) {
      const nonNlcStates = value.filter((state) => {
        return !nlcStates.includes(state);
      });
      selectedStates = nonNlcStates;
    } else {
      if (nlcStates.every((val) => value.includes(val))) {
        selectedStates.push(NLCMultiState);
      }
    }
    if (user?.agent?.license?.state) {
      selectedStates.push(user.agent.license.state);
    }
    selectedStates = Array.from(new Set(selectedStates));
    this.setState({ licensedStates: selectedStates });
    void this.saveAgent({ agentId: user._id, licensedStates: selectedStates });
  };

  updateNotes = ({ target: { value } }) => {
    this.setState({ notes: value });
  };

  onExpiryChange = (date) => {
    const { userId } = this.props;
    void this.saveAgent({
      agentId: userId,
      licenseExpires: date.format("YYYY-MM-DD"),
    });
  };

  handleProfileImageModal = ({ key }) => {
    this.setState({
      showProfileImageModal: {
        show: true,
        action: key,
      },
    });
  };

  getAgentStatusLogs = async () => {
    const { userId } = this.props;
    const { body } = await request
      .get(`${global.api}/agentProfile/status/logs`)
      .set(await getAuthHeader())
      .query({ userId });
    this.setState({ statusLogs: body.logs });
  };

  scheduleSoftDelete = async () => {
    const { userId } = this.props;
    try {
      await request
        .post(`${global.api}/agentProfile/requestAccountDeletion?hcpId=${userId}`)
        .set(await getAuthHeader())
        .send();
      await this.retrieveUser();
      await this.getAgentStatusLogs();
      this.closeDeleteUserModal();
    } catch (error: unknown) {
      logError("Error in WorkerDrawer - scheduleSoftDelete", { error });
      showErrorToast(getErrorMessage(error));
    }
  };

  handleDeleteUser = () => {
    this.setState({ deleteUserModalVisible: true });
  };

  closeDeleteUserModal = () => {
    this.setState({ deleteUserModalVisible: false });
  };

  toggleLoginBlocked = async () => {
    const { userId, profile } = this.props;
    const { user } = this.state;

    if (!profile?.roles?.includes(EMPLOYEE_ROLES.MANAGE_USER_LOGIN_BLOCKED)) {
      showErrorToast(
        "You do not have the MANAGE_USER_LOGIN_BLOCKED permission to perform this action."
      );
      return;
    }

    const currentLoginBlocked = user?.loginBlocked ?? false;
    const newLoginBlocked = !currentLoginBlocked;

    Modal.confirm({
      title: `Are you sure you want to ${newLoginBlocked ? "block" : "unblock"} login for ${
        user?.agent?.name
      }?`,
      content: newLoginBlocked
        ? "This will prevent the user from logging into their account."
        : "This will allow the user to log into their account.",
      onOk: async () => {
        try {
          await request
            .patch(`${global.api}/users/${userId}`)
            .set(await getAuthHeader())
            .send({
              loginBlocked: newLoginBlocked,
            });

          showSuccessToast(`Login ${newLoginBlocked ? "blocked" : "unblocked"} successfully.`);
          await this.retrieveUser();
        } catch (error: unknown) {
          logError("Error in WorkerDrawer - toggleLoginBlocked", { error });
          showErrorToast(getErrorMessage(error));
        }
      },
      okText: newLoginBlocked ? "Block Login" : "Unblock Login",
    });
  };

  render() {
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { userId, currentUserID, profile, ldFlags } = this.props;
    const { user, profileImageSrc } = this.state;
    const { agent = {}, zenDeskId } = user || {};
    const defaultSSNValue = SSN_DEFAULT_LABEL;
    const isAllowedToViewAnyKindOfSSN =
      profile?.roles?.includes(EMPLOYEE_ROLES.VIEW_FULL_SSN) ||
      profile?.roles?.includes(EMPLOYEE_ROLES.VIEW_PARTIAL_SSN);

    const canDeleteHcp = profile?.roles?.includes(EMPLOYEE_ROLES.DELETE_HCP_DATA);
    const agentHasRequestedDeletion =
      isDefined(user?.agent.requestedAccountDeletion) &&
      user.agent?.stage === WorkerStages.DELETION_REQUESTED;
    const agentIsSoftDeleted = user?.agent?.stage === WorkerStages.SOFT_DELETED;
    const isDeletionPendingOrDeleted = [
      WorkerStages.DELETION_REQUESTED,
      WorkerStages.SOFT_DELETED,
    ].includes(user?.agent?.stage);

    let showDeleteButton = false;
    let deleteButtonLabel = "";
    if (canDeleteHcp && !isDeletionPendingOrDeleted) {
      showDeleteButton = true;
      deleteButtonLabel = "Delete User";
    }

    const { zenDeskContact } = meta();
    const agentLicenses = getUniqueQualifications(agent?.licensesData);

    // Adapter: the drawer's "open" signal is the `userId` prop (caller
    // controls when to pass an id vs undefined). Wrap that into the redesign
    // Drawer's modalState shape. Open/setStatus are no-ops because open is
    // externally controlled; only close propagates back via `closeDrawer`.
    const modalState: UseModalState = {
      modalIsOpen: Boolean(userId),
      modalIsClosed: !userId,
      modalStatus: userId ? ModalStatus.OPEN : ModalStatus.CLOSED,
      setModalStatus: () => undefined,
      openModal: () => undefined,
      closeModal: this.handleClose,
    };

    // Override the redesign Drawer's default width — the worker details panel
    // is content-heavy, matching the legacy 60vw width.
    //
    // zIndex note: this drawer hosts antd Modals (DeleteUser, Requirements,
    // ProfileImage, WorkerStages) plus imperative `Modal.confirm` calls. Antd
    // Modals default to zIndex 1000; MUI's temporary Drawer sits at
    // theme.zIndex.modal (1300). Pin the drawer below antd's default so
    // nested antd surfaces stack on top.
    const drawerSx = {
      zIndex: 999,
      "& .MuiDrawer-paper": {
        width: { xs: "100%", md: "60vw" },
        maxWidth: "100%",
      },
    };

    if (!userId || !user) {
      return (
        <>
          <Drawer modalState={modalState} title="Worker Details" showCloseButton sx={drawerSx}>
            <Skeleton loading />
          </Drawer>
        </>
      );
    }

    const getInitialsFromName = (agentName, letterCount = 2) => {
      if (typeof agentName !== "string") {
        return agentName;
      }
      const separatedAgentName = agentName.split(" ");
      return separatedAgentName
        .reduce((acc, cur) => acc + (cur?.[0] ?? ""), "")
        .substring(0, letterCount);
    };

    const profileMenu = (
      <Menu onClick={this.handleProfileImageModal}>
        {agent.profileImageUrl && <Menu.Item key="view">View Image</Menu.Item>}
        <Menu.Item key="edit">Update</Menu.Item>
      </Menu>
    );
    const { firstName, lastName } = fullNameToFirstLast(agent.name);

    const { limited, warning } = this.props.ldFlags?.[
      CbhFeatureFlag.BASKET_SIZE_LIMIT_CONFIGURATION
    ] ?? {
      limited: { enabled: false },
      warning: { enabled: false },
    };
    let currentAgentStage = agent.stage;
    const currentAgentSubstage: WorkerSubstage | undefined = agent.substage;
    if (
      agent.stage === WorkerStages.ENROLLED &&
      limited.enabled &&
      agent.substage?.name === WorkerSubstages.LIMITED
    ) {
      currentAgentStage = WorkerSubstages.LIMITED;
    } else if (
      agent.stage === WorkerStages.ENROLLED &&
      warning.enabled &&
      agent.substage?.name === WorkerSubstages.WARNING
    ) {
      currentAgentStage = WorkerSubstages.WARNING;
    } else if (
      agent.stage === WorkerStages.RESTRICTED &&
      agent.substage?.name === WorkerSubstages.INVITE_REQUIRED
    ) {
      currentAgentStage = WorkerSubstages.INVITE_REQUIRED;
    }

    return (
      <div>
        <Drawer modalState={modalState} title="Worker Details" showCloseButton sx={drawerSx}>
          {/* Test Account toggle + Zendesk link — formerly rendered in the
              antd Drawer's title bar; the redesign Drawer's title slot is
              text-only, so they live at the top of the body now. */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            gap={2}
            sx={{ marginBottom: 2 }}
          >
            <span>Test Account</span>
            <Switch
              disabled={!profile?.roles?.includes(EMPLOYEE_ROLES.TEST_ACCOUNTS)}
              defaultChecked={agent.isTestAccount}
              onChange={(checked) => {
                void this.saveEditChanges(
                  {
                    agentId: user._id,
                    isTestAccount: checked,
                  },
                  true
                );
              }}
            />
            {zenDeskId && (
              <Button type="link" href={`${zenDeskContact}/${zenDeskId}`} target="_blank">
                <img style={{ width: "30px" }} src="/zenDesk.svg" alt="zendesk" />
              </Button>
            )}
          </Stack>

          {agentHasRequestedDeletion ? (
            <Box pb={2}>
              <Banner severity="warning">
                This professional submitted an account deletion request on{" "}
                {formatDateTimeWithTimeZone(
                  new Date(user?.agent.requestedAccountDeletion.createdAt)
                )}
                .
              </Banner>
            </Box>
          ) : null}

          {agentIsSoftDeleted ? (
            <Box pb={2}>
              <Banner severity="error">This account is deleted.</Banner>
            </Box>
          ) : null}

          <div>
            <div style={{ textAlign: "center", cursor: "pointer" }}>
              <Dropdown overlay={profileMenu} trigger={["click"]}>
                <Avatar
                  style={{ background: "#888888" }}
                  shape="circle"
                  size={100}
                  {...profileImageSrc}
                >
                  {getInitialsFromName(user.agent?.name)}
                </Avatar>
              </Dropdown>
            </div>
            {twoSpace}
            <Input
              addonBefore="User Id"
              style={{ width: "55%" }}
              addonAfter={
                isDefined(agent.userId) ? (
                  <CopyableText value={agent.userId} showText={false} />
                ) : null
              }
              disabled={true}
              value={agent.userId}
            />
            {twoSpace}
            <Input
              style={{ width: "55%" }}
              addonBefore="Full Name"
              placeholder="Name"
              value={agent.name}
              disabled={true}
              addonAfter={
                isDefined(agent.name) ? <CopyableText value={agent.name} showText={false} /> : null
              }
            />
            {twoSpace}
            <Edit
              addonBefore="First Name"
              placeholder="First Name"
              defaultValue={agent.firstName || firstName}
              eventFn={(value) =>
                this.saveEditChanges(
                  {
                    agentId: user._id,
                    firstName: value,
                    lastName: agent.lastName || lastName,
                    middleName: agent.middleName ?? "",
                  },
                  true
                )
              }
              addonAfter={
                isDefined(agent.firstName) ? (
                  <CopyableText value={agent.firstName} showText={false} />
                ) : null
              }
            />
            {twoSpace}
            <Edit
              addonBefore="Middle Name"
              placeholder="Middle Name"
              defaultValue={agent.middleName}
              eventFn={(value) =>
                this.saveEditChanges(
                  {
                    agentId: user._id,
                    middleName: value ?? "",
                    lastName: agent.lastName || lastName,
                    firstName: agent.firstName || firstName,
                  },
                  true
                )
              }
              addonAfter={
                isDefined(agent.middleName) ? (
                  <CopyableText value={agent.middleName} showText={false} />
                ) : null
              }
            />
            {twoSpace}
            <Edit
              addonBefore="Last Name"
              placeholder="Last Name"
              defaultValue={agent.lastName || lastName}
              eventFn={(value) =>
                this.saveEditChanges(
                  {
                    agentId: user._id,
                    lastName: value,
                    firstName: agent.firstName || firstName,
                    middleName: agent.middleName ?? "",
                  },
                  true
                )
              }
              addonAfter={
                isDefined(agent.lastName) ? (
                  <CopyableText value={agent.lastName} showText={false} />
                ) : null
              }
            />
            {twoSpace}
            <Edit
              addonBefore="Phone"
              placeholder="Phone"
              defaultValue={agent.phone}
              eventFn={(value) => this.saveEditChanges({ agentId: user._id, phone: value }, true)}
              addonAfter={
                isDefined(agent.phone) ? (
                  <CopyableText value={agent.phone} showText={false} />
                ) : null
              }
            />
            {twoSpace}
            <Edit
              addonBefore="Email"
              placeholder="Email"
              defaultValue={agent.email}
              eventFn={(value) => this.saveEditChanges({ agentId: user._id, email: value }, true)}
              addonAfter={
                isDefined(agent.email) ? (
                  <CopyableText value={agent.email} showText={false} />
                ) : null
              }
            />
            {twoSpace}
            {isAllowedToViewAnyKindOfSSN ? (
              <EditSSN
                addonBefore="SSN"
                placeholder="Social Security Number"
                isAllowedToViewFullSSN={profile?.roles?.includes(EMPLOYEE_ROLES.VIEW_FULL_SSN)}
                maxLength={9}
                agentId={agent.userId}
                defaultValue={defaultSSNValue}
                eventFn={(value) =>
                  /* @ts-expect-error FIXME this wrong type */
                  this.saveEditChanges({
                    agentId: user._id,
                    fullSocialSecurityNumber: value as string,
                  })
                }
              />
            ) : null}
            {twoSpace}
            <Edit
              addonBefore="Salesforce ID"
              placeholder="Salesforce ID"
              maxLength={18}
              defaultValue={agent.salesforceId}
              eventFn={(value) =>
                this.saveEditChanges({
                  agentId: user._id,
                  salesforceId: value,
                })
              }
            />
            {twoSpace}
            <Edit
              addonBefore="Video URL"
              placeholder="Video URL"
              defaultValue={agent.profileVideoUrl}
              eventFn={(value) =>
                this.saveEditChanges({
                  agentId: user._id,
                  profileVideoUrl: value,
                })
              }
            />
            {twoSpace}
            <div>
              <span>Date of Birth</span>&nbsp;&nbsp;
              <DatePicker
                format="MM/DD/YYYY"
                disabled={!profile?.roles?.includes(EMPLOYEE_ROLES.SHIFT_PRICING)}
                placeholder="Date of Birth"
                showToday={false}
                onBlur={this.confirmDobChange}
                onChange={this.dobChange}
                value={agent.dob ? moment(agent.dob) : undefined}
              />
            </div>
            {twoSpace}
            <div>
              <span>Sex</span>&nbsp;&nbsp;
              <Select
                style={{ width: 150 }}
                placeholder="Select sex"
                value={agent.sex || undefined}
                onChange={(value: WorkerSex) => {
                  void this.saveAgent({ agentId: user._id, sex: value }, true);
                }}
              >
                <Select.Option value="male">Male</Select.Option>
                <Select.Option value="female">Female</Select.Option>
                <Select.Option value="other">Other</Select.Option>
                <Select.Option value="unknown">Unknown</Select.Option>
              </Select>
            </div>
            {twoSpace}
            <div data-testid="signed-agreements-section">
              {agent.employmentStatus === EMPLOYMENT_STATUS.STATUS_W2 ? (
                "W2 – N/A"
              ) : (
                <WorkerSignedAgreementsSection workerId={agent.userId} />
              )}
            </div>
            {twoSpace}
            {[WorkerTypes.OR_RN, WorkerTypes.CRNA].some((surgeryLicense) =>
              agentLicenses.includes(surgeryLicense)
            ) && twoSpace}
            {twoSpace}
            <LicenseManager agentId={userId} agent={agent} />
            {twoSpace}
            <WorkerRolesManager workerId={userId} />
            {twoSpace}
            <LicenseChangeLogsCard workerId={userId} />
            {twoSpace}
            <HomeHealthWorkerEnabledToggle workerId={userId} />
            {twoSpace}
            <WorkerLockStatusDisplay workerId={userId} />
            {twoSpace}
            <div style={{ display: "flex", flexDirection: "column" }}>
              {!user.instantPayProhibited &&
                user.isStripeUser &&
                this.state.instantPayPercentage > 0 && (
                  <div>
                    <span>InstantPay Rate %</span>&nbsp;
                    <InputNumber disabled={true} defaultValue={this.state.instantPayPercentage} />
                    <Tooltip
                      title={
                        <div>
                          This HCP will earn {this.state.instantPayPercentage}% of their pay
                          immediately when the shift is over if they work at an InstantPay
                          workplace. The remaining will be paid after shift verification.
                        </div>
                      }
                    >
                      <InfoCircleOutlined style={{ marginLeft: 10 }} />
                    </Tooltip>
                  </div>
                )}
            </div>
            {twoSpace}
            <div>
              <span>Location</span>
              <br />
              <SelectLocations
                multiple={true}
                locations={this.props.locations}
                defaultValue={user.locations.map((loc) => loc._id)}
                onChange={(locations) => {
                  void this.saveAgent({
                    agentId: user._id,
                    locations: locations.map((loc) => loc._id),
                  });
                }}
              />
            </div>
            {twoSpace}
            <LocationContainer
              address={agent.address}
              location={agent.geoLocation}
              userId={user._id}
              retrieveUser={this.retrieveUser}
              saveUser={this.saveUser}
              type="AGENT"
              admin={currentUserID}
            />
            {twoSpace}
            <DisabledInputPopover
              placeholder={
                user.tmz +
                " - " +
                /* @ts-expect-error FIXME this wrong type */
                moment.tz(user.tmz).format("zz") +
                " (" +
                /* @ts-expect-error FIXME this wrong type */
                moment.tz(user.tmz).format("z") +
                ")"
              }
              inputName="Time Zone"
              popover="Time zones are automatically assigned based on the Address. Edit the Address to re-calculate the time zone."
            />
            {twoSpace}
            {/* FIXME: Automatically disabled during ESLint config update */}
            {/* eslint-disable-next-line @typescript-eslint/prefer-optional-chain */}
            {(agent.address && agent.address.metropolitanStatisticalArea === "No MSA Present") ||
            agent.address?.manualMsa ? (
              /* @ts-expect-error FIXME this wrong type */
              <SelectMetropolitanStatisticalArea
                agentId={user._id}
                defaultMetropolitanStatisticalArea={agent.address?.metropolitanStatisticalArea}
              />
            ) : (
              <DisabledInputPopover
                placeholder={agent.address?.metropolitanStatisticalArea}
                inputName="MSA"
                popover="MSAs are automatically assigned based on the Address. Edit the Address to re-calculate the MSA."
              />
            )}
            {twoSpace}
            <ShiftSearchPreference
              /* @ts-expect-error FIXME this wrong type */
              minDistance={1}
              maxDistance={150}
              step={1}
              agent={_.get(this.state, "user.agent", {})}
              admin={currentUserID}
            />
            {twoSpace}
            <NotificationPreference notificationPreferences={agent.notificationPreferences} />
            {twoSpace}
            <div>
              <span>Notes</span>&nbsp;
              <TextArea
                value={this.state.notes}
                placeholder="General notes"
                rows={2}
                onChange={this.updateNotes}
                onBlur={({ target: { value } }) =>
                  this.saveAgent({ agentId: user._id, note: value })
                }
              />
            </div>
            {twoSpace}
            {profile?.roles?.includes(EMPLOYEE_ROLES.DOCUMENTS) && (
              <>
                <UploadedDocs
                  agent={agent}
                  onUpdateDocument={this.onUpdateDocument}
                  agentTMZ={user?.tmz}
                />
                {twoSpace}
              </>
            )}
            {this.requirements(agent)}
            {twoSpace}
            <div>
              <AgentExperienceTags
                agent={agent}
                saveAgent={this.saveAgent}
                type="Facility Types"
                experienceType="FACILITY"
              />
            </div>
            {twoSpace}
            <div>
              <AgentExperienceTags
                agent={agent}
                saveAgent={this.saveAgent}
                type="Experience"
                experienceType="EXPERIENCE"
              />
            </div>
            {twoSpace}
            <div>
              <span>Availability</span>&nbsp;
              <TextArea
                defaultValue={agent.availNote}
                placeholder="Availability"
                rows={2}
                onBlur={(e) =>
                  this.saveAgent({
                    agentId: user._id,
                    availNote: e.target.value,
                  })
                }
              />
            </div>
            <br />
            <LogContainer
              type="AGENT"
              userId={userId}
              currentUserId={currentUserID}
              currentStage={agent.stage}
            />
            {twoSpace}
            <AgentPaymentsInfoCard agent={agent} refetchUser={this.retrieveUser} />
            {twoSpace}
            <AgentReferral agent={agent} />
            {twoSpace}
            <AgentAppLinksCard user={user} />
            {twoSpace}
            <StatusChangeLogsCard logs={this.state.statusLogs} tmz={agent.tmz} type="Worker" />
            {twoSpace}
            <ProfileChangeLogsCard id={user._id} />
            {twoSpace}
            <Button type="primary" onClick={this.refreshAttendance}>
              Refresh Attendance
            </Button>
            {twoSpace}
            <SyncWorkerWithZendeskButton workerId={agent.userId} />
            {twoSpace}
            <ViewUXCamSessionsButton workerId={agent.userId} />
            {twoSpace}
            <FirebaseSyncButton userId={user._id} retrieveUser={this.retrieveUser} />
            {twoSpace}
            <WorkerStagesButtonGroup
              selectedStage={currentAgentStage}
              onSelected={(stage) => {
                // do not allow setting the stage to DELETION_REQUESTED or SOFT_DELETED
                // there's a separate button below to "Delete User"
                if ([WorkerStages.DELETION_REQUESTED, WorkerStages.SOFT_DELETED].includes(stage)) {
                  return;
                }
                if (
                  [
                    WorkerStages.ONBOARDING,
                    WorkerStages.ENROLLED,
                    WorkerSubstages.LIMITED,
                    WorkerSubstages.WARNING,
                  ].includes(stage)
                ) {
                  this.updateAgentStage(stage, currentAgentSubstage).catch(() => {});
                  return;
                }
                this.setState({
                  selectedStage: stage,
                  isStagesModalVisible: true,
                });
              }}
              disabled={!profile?.roles?.includes(EMPLOYEE_ROLES.WORKER_ACCOUNT_STATUS_MANAGER)}
            />
            {twoSpace}
            {profile?.roles?.includes(EMPLOYEE_ROLES.MANAGE_USER_LOGIN_BLOCKED) && (
              <>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span>Login Blocked:</span>
                  <Switch
                    checked={user?.loginBlocked ?? false}
                    onChange={this.toggleLoginBlocked}
                  />
                  <Tooltip title="When enabled, the user will not be able to log into their account. This DOES NOT fully disable the user and will not prevent actions such as opening Zendesk tickets.">
                    <InfoCircleOutlined style={{ color: "#1890ff" }} />
                  </Tooltip>
                </div>
                {twoSpace}
              </>
            )}
            {showDeleteButton && (
              <>
                <Button
                  ghost
                  /* @ts-expect-error FIXME this wrong type */
                  type="danger"
                  onClick={this.handleDeleteUser}
                >
                  {deleteButtonLabel}
                </Button>
                {twoSpace}
              </>
            )}
            <div>
              <span>Onboarding workflow:</span>&nbsp;&nbsp;
              {_.get(user, "agent.onboardingFlags.onboardingWorkflow", "LEGACY")}
            </div>
            <span>
              <br />
              Added by {user.addedBy ? user.addedBy.email : "(unknown)"}
            </span>
          </div>
        </Drawer>
        <DeleteUserModal
          visible={this.state.deleteUserModalVisible}
          onConfirm={this.scheduleSoftDelete}
          onCancel={this.closeDeleteUserModal}
          userId={userId}
        />
        <RequirementsModal
          title="Set Requirements Fulfilled for Agent"
          isVisible={this.state.editingDocuments}
          hasExpirations={true}
          requireExpirations={true}
          documents={this.props.documents}
          init={agent.requirements || []}
          save={({ addedReqDocs, removedRequirements, updatedReqDocs }) => {
            // addedReqDocs is an array of {requirementId, expires}
            // removedRequirements is an array of requirementId's
            // updatedReqDocs is an array of {requirementId, expires}
            const requirements = {
              addedReqDocs,
              removedRequirements,
              updatedReqDocs,
            };

            this.updateAgentRequirements(requirements)
              .then(() => {
                showInfoToast("Requirements updated");
                void this.retrieveUser();
              })
              .catch((err) => showErrorToast("" + err));

            this.setState({ editingDocuments: false });
          }}
          cancel={() => this.setState({ editingDocuments: false })}
        />
        <ProfileImageModal
          visible={this.state.showProfileImageModal.show}
          action={this.state.showProfileImageModal.action}
          onCancel={() =>
            this.setState({
              showProfileImageModal: { show: false, action: undefined },
            })
          }
          agentId={userId}
          retrieveUser={this.retrieveUser}
          url={agent.profileImageUrl || ""}
        />
        <WorkerStagesModal
          isVisible={this.state.isStagesModalVisible && !!this.state.selectedStage}
          stage={this.state.selectedStage}
          substage={currentAgentSubstage}
          onAccept={this.updateAgentStage}
          onCancel={() => {
            this.setState({ isStagesModalVisible: false });
          }}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      pseudo,
    },
    dispatch
  );

export default withLDConsumer()(
  withRouter(
    connect(
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (state: any) => ({
        currentUserID: state.session.adminUserId,
        profile: state.session.adminProfile,
        locations: state.locations.locations,
        admins: state.employees.employees,
      }),
      mapDispatchToProps
    )(WorkerDrawer)
  )
);
